import { useQuery } from "@tanstack/react-query";
import { t } from "ttag";

import { ErrorState } from "@/app/components/legacy-components";
import { consultationsQueriesStore } from "@/features/consultations/api";
import { AppointmentCard } from "@/features/consultations/components";
import {
  CalendarIcon,
  Card,
  CardSkeleton,
  Carousel,
  EmptyState,
  VideoCameraIcon,
} from "@/shared/ui";
import { tw } from "@/shared/utils";

export const UpcomingConsultations = () => {
  const {
    data: upcomingConsultations,
    isLoading,
    isError,
    isSuccess,
  } = useQuery(
    consultationsQueriesStore.consultations.appointments._ctx.list._ctx.upcoming
      ._ctx.medicationRequest,
  );

  return (
    <Card.Root ghost>
      <Card.Title icon={VideoCameraIcon}>
        {t`Upcoming consultations`}
      </Card.Title>

      <Card.Content>
        {isLoading && (
          <CardSkeleton className="h-44 w-11/12 border bg-transparent sm:w-7/12 2xl:w-5/12" />
        )}

        {isError && <ErrorState />}

        {isSuccess && !upcomingConsultations.length && (
          <EmptyState.Root>
            <EmptyState.Icon>
              <CalendarIcon />
            </EmptyState.Icon>
            <EmptyState.Description>
              {t`There are no upcoming consultations yet`}
            </EmptyState.Description>
          </EmptyState.Root>
        )}

        {isSuccess && Boolean(upcomingConsultations.length) && (
          <Carousel.Root className="w-full">
            <Carousel.Content className="ml-0 flex gap-4">
              {upcomingConsultations.map((appointment) => (
                <AppointmentCard
                  key={appointment.id}
                  appointment={appointment}
                  className={tw(
                    "max-w-11/12 min-w-11/12 sm:max-w-7/12 sm:min-w-7/12 2xl:max-w-5/12 2xl:min-w-5/12",
                    upcomingConsultations.length === 1 && "min-w-full",
                  )}
                />
              ))}
            </Carousel.Content>

            <Carousel.PreviousButton />
            <Carousel.NextButton />
          </Carousel.Root>
        )}
      </Card.Content>
    </Card.Root>
  );
};
